import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeModal, hideLoading } from "../reducers/modalsSlice";

import styles from  "../styles/components/Modal.module.css";
import Modal from "./Modal";

const ModalsSystem = () => {
  const modals = useSelector((state) => state.modals);
  const dispatch = useDispatch();

  const handleClose = (id) => {
    dispatch(closeModal(id));
    dispatch(hideLoading());
  };

  const handleConfirm = (data) => {
    data.onConfirm();
    handleClose(data.id);
  }

  // console.log(modals);
  return (
    <div className={styles.notificationContainer}>
      {modals.map((data) => (
		    <Modal
          key={data.id}
          message={data.message}
          type={data.type}
          onClose={() => handleClose(data.id)}
          onConfirm={() => handleConfirm(data)}
        />
      ))}
    </div>
  );
};

export default ModalsSystem;
